import {AfterViewInit, Component, ElementRef, Injector, OnInit, ViewChild} from "@angular/core";
import {BaseComponentDirective} from "../../_shared/base/base.component";
import {UserService} from "../dashboard/services/user.service";
import {InformationDialog} from "../../_shared/dialog/information.dialog";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {FileStorageService} from "../../_services/filestorage.service";

@Component({
    selector: 'app-conversation',
    templateUrl: './conversation.component.html',
    styleUrls: ['./email-agent.component.scss']
})
export class ConversationComponent extends BaseComponentDirective implements OnInit, AfterViewInit {
    fileUrl: string | ArrayBuffer;
    fd: FormData;
    ticket: any = {};
    user: any = {};
    form: FormGroup;
    uploading = false;
    hasAttachment = false;
    @ViewChild('scrollContainer') private scrollContainer!: ElementRef;
    constructor(
        injector: Injector,
        private userService: UserService,
        private formBuilder: FormBuilder,
        private fileStorageService: FileStorageService
    ) {
        super(injector);
        this.form = this.formBuilder.group({
            message: [null, [Validators.required, Validators.minLength(5)]]
        });
    }

    override ngOnInit() {
        super.ngOnInit();
        this.profileMsg.currentMessage.subscribe(r => {
            if(r) {
                this.user = r;
                this.callConversation();
            }
        })
    }

    ngAfterViewInit() {
        setTimeout(() => this.scrollToBottom(), 2000);
    }

    private scrollToBottom(): void {
        this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight + 150;
    }

    callConversation() {
        this.userService.getWalletSupportDetails(this.activatedRoute.snapshot.params.id).then(r => {
            this.ticket = r;
            this.ticket.walletSupportDetails.sort((a:any, b:any) => a.id - b.id);
        }, _ => {
            const dialog = this.dialog.open(InformationDialog, {
                data: {
                    title: 'Error',
                    message: 'Invalid Wallet Support.',
                    subMessage: 'cannot populate your ticket conversation, please choose from wallet support list'
                }
            })
            dialog.afterClosed().subscribe(r => {
                this.router.navigate(['/wallet-support']).then();
            })

        })
    }

    getFileChange($event: FileList): void {
        this.fd = new FormData();
        const fileTransfer = $event[0];
        this.fd.append('file', fileTransfer);
        this.form.controls.message.setValue(this.form.controls.message.value?? " " + " a file attached to message")
    }

    sendMessage() {

        if(this.ticket.status == 'OPEN') {

            const validation = this.check(this.form);
            if(validation) {
                this.showAlert('Warning', '', 'Please complete all required fields. Your message cannot be empty, and it must be at least 5 characters long.');
                return;
            }

            this.uploading = true;
            this.form.controls.message.disable();

            this.userService.replyWalletSupportTicket(
                this.form.controls.message.value,
                this.activatedRoute.snapshot.params.id,
                false
            ).then(r => {
                if(this.hasAttachment) {
                    this.userService.uploadFileAttachment(this.fd, r.id).then(_ => {
                        this.callConversation();
                        this.showAlert('Message Submitted!', 'Your message has been saved successfully.', "You'll receive an email notification when our administrator responds.");
                        this.snackBar.open('Message has been saved successfully', null, {duration: 3000, verticalPosition: 'top', horizontalPosition: 'right'});
                        this.form.reset();
                        this.form.markAsPristine();
                        this.form.markAsUntouched();
                        this.form.controls.message.enable();
                        this.uploading = false;
                        this.fd = new FormData();
                        this.fileUrl = null;
                        this.hasAttachment = false;
                        setTimeout(() => this.scrollToBottom(), 2000);
                    });
                } else {
                    this.callConversation();
                    this.showAlert('Message Submitted!', 'Your message has been saved successfully.', "You'll receive an email notification when our administrator responds.");
                    this.snackBar.open('Message has been saved successfully', null, {duration: 3000, verticalPosition: 'top', horizontalPosition: 'right'});
                    this.form.reset();
                    this.form.markAsPristine();
                    this.form.markAsUntouched();
                    this.form.controls.message.enable();
                    this.uploading = false;
                    this.fd = new FormData();
                    this.fileUrl = null;
                    this.hasAttachment = false;
                    setTimeout(() => this.scrollToBottom(), 2000);
                }

            });
        } else {
            this.showAlert('Information', 'This ticket is closed and you no longer able to send message to this conversation', 'Please open new ticket if you still have any question')
        }


    }

    downloadAttachment(attachmentId: number, fileName: string) {
        this.fileStorageService.getAttachmentUrl(attachmentId, fileName);
    }

    downloadAttachmentFromAdmin(attachmentId: number, fileName: string) {
        this.fileStorageService.getAttachmentUrlFromAdmin(attachmentId, fileName);
    }

    goBack() {
        this.router.navigate(['/wallet-support']).then();
    }
}